<template>
  <div class="share-container" :style="finalShareSetting.mainStyle">
    <div
      class="share-item"
      :class="[activeIndex === item.id ? 'active-share-item' : '']"
      v-for="(item, index) in shareList"
      :key="index"
      :style="shareBtnStyle"
      @click.stop="changeShareType(item.id)"
      @mouseenter.stop="mouseenterEv(item.id)"
      @mouseleave.stop="mouseleaveEv(item.id)"
      v-show="item.isShow"
      ref="shareItem"
    >
      <div :class="['share-box', item.iconPosition === 'left' || item.iconPosition === 'right' ? 'flex' : '']">
        <icon-set
          :icon="item"
          :isActive="activeIndex === item.id" 
          :isHover="hoverIndex === item.id" 
          v-if="item.iconSrc && (item.iconPosition === 'top' || item.iconPosition === 'left')"
        />
        <div v-if="item.name" ref="textOuter" 
          :class="['text-outer', activeIndex === item.id ? 'active' : hoverIndex === item.id ? 'hover' : '']">
          {{ item.name }}
        </div>
        <icon-set
          :icon="item"
          :isActive="activeIndex === item.id" 
          :isHover="hoverIndex === item.id" 
          v-if="item.iconSrc && (item.iconPosition === 'bottom' || item.iconPosition === 'right')"
        />
      </div>
      <div class="code-box" :style="getCodePositon" v-if="item.id === hoverIndex && (hoverIndex === 0 || hoverIndex === 2)">
        <div :id="'qrcode' + Object.values(myid).join('')"></div>
        <p class="text">扫码分享至{{ item.id === 0 ? "微信" : "qq" }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import iconSet from "./icon-set.vue"
import { getFinalConfigAndStyles } from "materials/navMenu/render/customSubMenus/setting/getFinalConfigAndStyles"
import { props as mainProps } from "../toolbars/shareConfigs/mainConfig/props"
import { props as shareBtnProps } from "../toolbars/shareConfigs/shareItemBtn/props"
import QRCode from "qrcodejs2"
export default {
  name: "cxShare",
  components: {
    iconSet,
  },
  mixins: [],
  props: {
    options: {
      default: () => {},
      type: Object
    },
    myid: {
      type: Object,
      default: null
    }
  },
  computed: {
    finalShareSetting() {
      const { mainConfig = {}, shareBtnConfig = {} } = this.options
      const [finalShareBtnConfig, finalShareBtnStyle] = getFinalConfigAndStyles(shareBtnProps, shareBtnConfig)
      const [finalMainConfig, finalMainStyle] = getFinalConfigAndStyles(mainProps, mainConfig)

      if (finalShareBtnConfig.activeIsSameWithHover) {
        // 悬浮状态同选中状态， 悬浮状态样式也用选中状态的样式
        finalShareBtnConfig.btnTextHover = finalShareBtnConfig.btnTextActive
        finalShareBtnConfig.btnBackgroundHover = finalShareBtnConfig.btnBackgroundActive
        finalShareBtnConfig.btnBorderHover = finalShareBtnConfig.btnBorderActive
        finalShareBtnConfig.btnRadiusHover = finalShareBtnConfig.btnRadiusActive
        finalShareBtnConfig.btnOpacityHover = finalShareBtnConfig.btnOpacityActive
        finalShareBtnConfig.btnShadowHover = finalShareBtnConfig.btnShadowActive
      }
      const [, mergedShareBtnStyle] = finalShareBtnConfig.activeIsSameWithHover
        ? getFinalConfigAndStyles(shareBtnProps, finalShareBtnConfig, finalShareBtnConfig)
        : [, finalShareBtnStyle]
      return {
        shareBtnConfig: finalShareBtnConfig,
        mainConfig: finalMainConfig,
        shareBtnStyle: mergedShareBtnStyle,
        mainStyle: finalMainStyle,
        finalStyle: {
          "--page-theme-color": this.$store.state[this.request_prefix].page.themeColor
        }
      }
    },
    mainConfig() {
      return this.finalShareSetting?.mainConfig
    },
    shareBtnConfig() {
      return this.finalShareSetting?.shareBtnConfig
    },
    shareBtnStyle() {
      return this.finalShareSetting?.shareBtnStyle
    },
    shareList() {
      return this.options.itemList.map(item =>{
        item.iconSize = this.shareBtnConfig.iconSize
        item.iconMargin = this.shareBtnConfig.iconMargin
        item.iconPosition = this.shareBtnConfig.iconPosition
        return item
      })
    },
    getCodePositon() {
      const shareItem = this.$refs.shareItem[this.hoverIndex]
      if (!shareItem) return {}
      if (this.mainConfig?.direction === "row") {
        const top = parseInt(shareItem.getBoundingClientRect()?.height) + 10
        return {
          top: top + "px",
          left: 0
        }
      } else {
        const right = parseInt(shareItem.getBoundingClientRect()?.width) + 10
        return {
          top: 0,
          right: right + "px"
        }
      }
    }
  },
  data() {
    return {
      hoverIndex: -1,
      activeIndex: -1
    }
  },
  watch: {
    currentActiveShare(newVal, oldVal) {
      oldVal && this.publishUpdate()
    }
  },
  mounted() {
  },
  methods: {
    changeShareType(id) {
      this.activeIndex = id
    },
    mouseenterEv(id) {
      this.hoverIndex = id
      if (id === 0 || id === 2) {
        this.$nextTick(()=> {
          this.generateQrcode()
        })
      }      
    },
    mouseleaveEv() {
      this.hoverIndex = -1
    },
    generateQrcode() {
      let id = "qrcode" + Object.values(this.myid).join('')
      document.getElementById(id).innerHTML = ""
      const { pageId } = this.$store.state.states.getDataPageIds
      let url = window.location.protocol + "//" + window.location.host + `/v2/p/${pageId}`
      this.qrcode = new QRCode(id, {
        width: 100,
        height: 100,
        text: url, // 二维码地址
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.share-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: var(--direction);
  gap: var(--margin);
  width: 100%;
  height: 100%;
  justify-content: center;
  border-width: var(--mainBorder_borderWidth);
  border-color: var(--mainBorder_borderColor) !important;
  border-style: var(--mainBorder_borderStyle);
  background-repeat: var(--mainBackground_backgroundRepeat);
  background-image: var(--mainBackground_backgroundImage);
  background-color: var(--mainBackground_backgroundColor);
  background-size: var(--mainBackground_backgroundSize);
  background-position: var(--mainBackground_backgroundPosition);
  border-radius: var(--mainRadius);
  opacity: var(--mainOpacity);
  box-shadow: var(--mainShadow);
  padding: var(--mainPadding);
  .share-item {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .share-box {
    width: 100%;
    height: 100%;
  }
}
.share-item {
  position: relative;
  width: var(--btnSize_width);
  height: var(--btnSize_height);
  border-width: var(--btnBorder_borderWidth);
  border-color: var(--btnBorder_borderColor) !important;
  border-style: var(--btnBorder_borderStyle);
  background-repeat: var(--btnBackground_backgroundRepeat);
  background-image: var(--btnBackground_backgroundImage);
  background-color: var(--btnBackground_backgroundColor);
  background-size: var(--btnBackground_backgroundSize);
  background-position: var(--btnBackground_backgroundPosition);
  border-radius: var(--btnRadius);
  opacity: var(--btnOpacity);
  box-shadow: var(--btnShadow);
  padding: var(--btnPadding);
  &:hover {
    border-width: var(--btnBorderHover_borderWidth);
    border-color: var(--btnBorderHover_borderColor) !important;
    border-style: var(--btnBorderHover_borderStyle);
    background-repeat: var(--btnBackgroundHover_backgroundRepeat);
    background-image: var(--btnBackgroundHover_backgroundImage);
    background-color: var(--btnBackgroundHover_backgroundColor);
    background-size: var(--btnBackgroundHover_backgroundSize);
    background-position: var(--btnBackgroundHover_backgroundPosition);
    border-radius: var(--btnRadiusHover);
    opacity: var(--btnOpacityHover);
    box-shadow: var(--btnShadowHover);
    padding: var(--btnPadding);
  }
  &.active-share-item {
    border-width: var(--btnBorderActive_borderWidth);
    border-color: var(--btnBorderActive_borderColor) !important;
    border-style: var(--btnBorderActive_borderStyle);
    background-repeat: var(--btnBackgroundActive_backgroundRepeat);
    background-image: var(--btnBackgroundActive_backgroundImage);
    background-color: var(--btnBackgroundActive_backgroundColor);
    background-size: var(--btnBackgroundActive_backgroundSize);
    background-position: var(--btnBackgroundActive_backgroundPosition);
    border-radius: var(--btnRadiusActive);
    opacity: var(--btnOpacityActive);
    box-shadow: var(--btnShadowActive);
    padding: var(--btnPadding);
  }
}

.flex {
  display: flex;
  align-items: center;
}
.code-box {
  position: absolute;
  z-index: 999;
  width: 124px;
  height: 149px;
  padding: 12px 0;
  box-sizing: border-box;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  flex-direction: column;
  .text {
    font-size: 12px;
    color: rgba(102, 102, 102, 1);
    margin-top: 8px;
  }
}
.text-outer {
  display: inline-block;
  width: 100%;
  font-style: var(--btnText_fontStyle);
  font-Family: var(--btnText_fontFamily);
  text-indent: var(--btnText_textIndent);
  font-size: var(--btnText_fontSize);
  font-weight: var(--btnText_fontWeight);
  line-height: var(--btnText_lineHeight);
  text-align: var(--btnText_textAlign);
  writing-mode: var(--btnText_writingMode);
  letter-spacing: var(--btnText_letterSpacing);
  color: var(--btnText_fontColor);
  text-decoration: var(--btnText_textDecoration);
  text-shadow: var(--btnText_textShadow);
  box-sizing: border-box;
  &.hover {
    font-style: var(--btnTextHover_fontStyle);
    font-Family: var(--btnTextHover_fontFamily);
    text-indent: var(--btnTextHover_textIndent);
    font-size: var(--btnTextHover_fontSize);
    font-weight: var(--btnTextHover_fontWeight);
    line-height: var(--btnTextHover_lineHeight);
    text-align: var(--btnTextHover_textAlign);
    writing-mode: var(--btnTextHover_writingMode);
    letter-spacing: var(--btnTextHover_letterSpacing);
    color: var(--btnTextHover_fontColor);
    text-decoration: var(--btnTextHover_textDecoration);
    text-shadow: var(--btnTextHover_textShadow);
  }
  &.active {
    font-style: var(--btnTextActive_fontStyle);
    font-Family: var(--btnTextActive_fontFamily);
    text-indent: var(--btnTextActive_textIndent);
    font-size: var(--btnTextActive_fontSize);
    font-weight: var(--btnTextActive_fontWeight);
    line-height: var(--btnTextActive_lineHeight);
    text-align: var(--btnTextActive_textAlign);
    writing-mode: var(--btnTextActive_writingMode);
    letter-spacing: var(--btnTextActive_letterSpacing);
    color: var(--btnTextActive_fontColor);
    text-decoration: var(--btnTextActive_textDecoration);
    text-shadow: var(--btnTextActive_textShadow);
  }
}
</style>